import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { StatItemRedesign } from 'app/fragments/overview-fragment/common/StatItem';
import { useRecoilState } from 'recoil';
import { OverviewStatItemProps } from '../../overview-fragment/common/OverviewStatItem';
import { displayPeriod } from '../../module-header-fragment/layout';
import { selectedFilterAtom } from '../../../state/recoil/atoms';
import { formatMoneyWithPrefix } from '../../../utils/formatMoneyWithPrefix';

interface FragmentNavigatorProps {
  period: string;
  valueLabel?: string;
  totalBudget?: number;
  items: OverviewStatItemProps[];
}

export const FragmentNavigator = (props: FragmentNavigatorProps) => {
  const [selectedFilters] = useRecoilState(selectedFilterAtom);

  return (
    <Grid
      container
      item
      md={12}
      lg={12}
      css={`
        //height: 89px;
        padding-right: 0 !important;
        padding-bottom: 0 !important;
        min-height: 89px;
        background-color: #f7f7f7;
        @media (max-width: 1440px) {
          box-shadow: -669px 0px 0px 0px #f7f7f7, 669px 0px 0px 0px #f7f7f7;
        }
        @media (max-width: 800px) {
          box-shadow: -300px 0px 0px 0px #f7f7f7, 300px 0px 0px 0px #f7f7f7;
        }
        @media (max-width: 600px) {
          box-shadow: -100px 0px 0px 0px #f7f7f7, 100px 0px 0px 0px #f7f7f7;
        }
        box-shadow: -960px 0px 0px 0px #f7f7f7, 960px 0px 0px 0px #f7f7f7;
      `}
    >
      <Grid
        item
        md={12}
        lg={3}
        css={`
          display: flex;
          flex-direction: column;
          align-self: center;
        `}
      >
        <React.Fragment>
          <Typography
            css={`
              font-family: Inter;
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 20px;
              display: flex;
              align-items: center;
              color: #2e4063;
              margin-bottom: 8px;
            `}
          >
            {props.valueLabel} {displayPeriod(selectedFilters)}
          </Typography>
        </React.Fragment>
      </Grid>

      <Grid
        item
        md={12}
        lg={9}
        css={`
          align-self: flex-end;
          place-content: flex-end;
          display: flex;
          margin-top: 16px;
          @media (max-width: 960px) {
            overflow: auto;
          }
        `}
      >
        <div
          css={`
            display: flex;
            @media (max-width: 960px) {
              overflow: auto;
            }
          `}
        >
          {props.items.map((item: OverviewStatItemProps, index: number) => (
            <StatItemRedesign
              index={index}
              label={item.label}
              value={item.value}
              path={item.path}
              disabled={item.disabled}
              key={`filter-item-${item.label}`}
            />
          ))}
        </div>
      </Grid>
    </Grid>
  );
};
